 {
    "common": {
    "thisWeek": "Denne uge",
    "lastWeek": "Sidste uge",
    "lastNumberOfDays": "Sidste {numberOfDays} dage",
    "thisMonth": "Denne måned"
    },
    "subAccounts": "Underkonti",
    "submitFeedback": "Indsend feedback",
    "createSubAccount": "Opret underkonto",
    "viewScheduleReports": "Vis planlagte rapporter",
    "searchSubAccount": "Søg efter underkonto",
    "columns": "Kolonner",
    "sortBy": "Sortér efter",
    "selectColumns": "Vælge kolonner",
    "maxColumns": "Maks. 8 kolonner ved en Dato",
    "applyColumns": "Anvend kolonner",
    "activeUsers": "Aktive brugere",
    "appointments": "Aftaler",
    "contacts": "Kontakter",
    "emails": "Gmail",
    "textMessages": "Indhold beskeder",
    "calls": "Opkald",
    "submissions": "Indsendelser",
    "reviews": "Anmeldelser",
    "sitesCreated": "Websites oprettet",
    "name": "Navn",
    "formSubmissions": "Indsendelser af formularer",
    "surveySubmissions": "Indsendelser af undersøgelser",
    "facebookFormSubmissions": "Indsendelser af Facebook-formularer",
    "funnels": "Tragter",
    "websites": "Websites",
    "forms": "Formularer",
    "surveys": "Undersøgelser",
    "highestFirst": "Maks. først",
    "lowestFirst": "Laveste først",
    "orderBy": "Sortere Via",
    "noMoreLocations": "Der er ikke fundet flere Adresse",
    "preparingReport": "Vi er ved at udarbejde din rapport …",
    "preparingReportDesc": "Luk eller genindlæs ikke dette vindue, mens eksporten er i gang.",
    "outOf": "Fra",
    "subAccountsExported": "Underkonti eksporteret",
    "close": "Luk",
    "scheduledForDeletion": "Planlagt til sletning",
    "readyToSell": "Parat til at sælge",
    "closedWon": "Lukket (vundet)",
    "wpSaleSuccessful": "WordPress-salget er lykkedes",
    "wpNotSold": "WordPress ikke solgt endnu",
    "yxtSaleSuccessful": "Yext salg er lykkedes",
    "yxtNotSold": "Den næste ikke solgt endnu",
    "saasSubInactive": "SaaS abonnement er inaktiv",
    "saasSubTrialing": "SaaS Abonnement er på prøve",
    "saasSubActive": "SaaS abonnement er dynamisk",
    "emailRebillingActive": "E-mail Genfakturering er Dynamisk",
    "emailRebillingInactive": "E-mail Genfakturering er Inaktiv",
    "twilioRebillingActive": "Twilio Genfakturering er Dynamisk",
    "twilioRebillingInactive": "Twilio Genfakturering er Inaktiv",
    "wpRebillingActive": "WhatsApp-genfakturering er aktiv",
    "wpRebillingInactive": "WhatsApp-genfakturering er inaktiv",
    "saasModeActivated": "SaaS -tilstand er Aktiveret",
    "paymentPending": "Betalingen afventer",
    "saasModeNotActivated": "SaaS -tilstand er ikke Aktiveret",
    "managedByLCPhone": "Administrator Via LC Telefon",
    "migrationToLCPhone": "Under migrering til LC Telefon",
    "notManagedByLCPhone": "Ikke administrator Via LC Telefon",
    "managedByLCEmail": "Administrator Via LeadConnector Email System",
    "notMangedByLCEmail": "Ikke administrator Via LeadConnector Email System",
    "remainingWalletBalance": "Resterende saldo på tegnebogen for denne SaaS-placering",
    "reports": "Rapporter",
    "switchToSubAccount": "Skift til underkonto",
    "manageClient": "Administrer kunde",
    "subAccountDeletedIfChangedMind": "Denne underkonto vil blive slettet den {time}, hvis du har skiftet mening",
    "subAccountDeletedInMinute": "Denne underkonto slettes inden for det næste minut",
    "changedMind": "Hvis Du've Dynamisk dit sind",
    "clickHere": "klik på hende",
    "subAccountPaused": "Denne underkonto er sat på pause. Dine kunder kan ikke logge ind, men bureauet kan. For at genoptage denne konto",
    "subAccountRestricted": "Denne underkonto er sat på pause på grund af afventende godkendelse.",
    "subAccountVerificationPending": "Denne underkonto er sat på pause på grund af afventende e-mail- og telefonbekræftelse fra underkontoadministratoren.",
    "subAccountDeclined": "Denne underkonto er sat på pause på grund af en afvist godkendelsesanmodning. Du kan stadig genoptage denne underkonto fra ",
    "here": "her.",
    "reviewAndResume": "for at gennemgå og genoptage denne underkonto.",
    "incomingCalls": "Indgående opkald",
    "outgoingCalls": "Udgående opkald",
    "totalTalktime": "Sum taletid",
    "incomingEmails": "Indgående Gmail",
    "outgoingEmails": "Udgående Gmail",
    "incomingSms": "Indgående Indhold-beskeder",
    "outgoingSms": "Udgående Indhold-beskeder",
    "contactsCreated": "Samlet antal oprettede kontakter",
    "appointmentsBooked": "Samlet antal bookede aftaler",
    "totalFormSubmissions": "Sum formularindsendelser",
    "totalSurveySubmissions": "Sum Undersøgelse indsendelser",
    "totalFacebookFormSubmissions": "Sum Facebook-formular indsendelser",
    "incomingGMBMessages": "Indgående GBP-beskeder",
    "outgoingGMBMessages": "Udgående GBP-beskeder",
    "gmbMessages": "GBP-beskeder",
    "fbMessages": "Facebook-beskeder",
    "incomingFbMessages": "Indgående Facebook-beskeder",
    "outgoingFbMessages": "Udgående Facebook-beskeder",
    "igMessages": "Instagram-beskeder",
    "incomingIgMessages": "Indgående Instagram-beskeder",
    "outgoingIgMessages": "Udgående Instagram-beskeder",
    "totalReviews": "Anmeldelser i Sum",
    "positiveReviews": "Positive anmeldelser",
    "negativeReviews": "Negative anmeldelser",
    "back": "Tilbage",
    "selectDashboards": "Vælge kontrolpaneler",
    "next": "Næste",
    "backToSubAccounts": "Tilbage til underkonti",
    "pauseSchedule": "Sæt skema på Pause",
    "resumeSchedule": "Genoptage skema",
    "editSchedule": "Rediger skema",
    "addSchedule": "Tilføj skema",
    "selectReportToAdd": "Vælge rapporterer til Inkludere in e-mailen",
    "selectAll": "Vælge hver",
    "pauseScheduleConfirm": "Er du sikker på, at du vil sætte rapportskemaet på Pause ?",
    "resumeScheduleConfirm": "Er du sikker på, at du vil genoptage rapportskemaet?",
    "tasks": "Opgaver",
    "conversations": "Samtaler",
    "users": "Bruger",
    "dealOverview": "Oversigt over Aftale",
    "confirmAction": "Bekræft handling",
    "yes": "Ja",
    "no": "Nej",
    "reportDetails": "Rapportoplysninger",
    "reportCreatedOn": "Rapport Oprettet Til",
    "searchByEmail": "Søge Via E-mail",
    "lastActivity": "Sidste aktivitet",
    "noRecords": "Ingen poster fundet",
    "scheduleReport": "Planlæg rapport",
    "schedule": "skema",
    "save": "Gem",
    "emailSubject": "Emnelinje",
    "frequency": "Frekvens",
    "daily": "Daglig",
    "weekly": "Ugentlig",
    "monthly": "Månedlig",
    "nextScheduleDate": "Næste skema Dato",
    "startingOn": "Starter til",
    "timeOfDay": "Dato af Dag",
    "reportsToTimezone": "Rapporten vil blive sendt i underkontoens tidszone",
    "selectRecipients": "Vælge modtagere",
    "invalidEmail": "Indtast en gyldig e-mailadresse.",
    "testEmail": "Test",
    "selectTestRecipients": "Vælg Test",
    "setupSubject": "Konfigurer Emne ovenfor for at Test rapporten",
    "sendTest": "Upload",
    "scheduleSimilarSchedules": "Planlæg en lignende rapport for andre underkonti",
    "accountSummary": "Kontooversigt",
    "scheduleList": "Liste over skemaer",
    "subAccountName": "Navn på underkonto",
    "nextRunDate": "Næste kørselsdato",
    "reportSectionsAdded": "Rapportsektioner tilføjet",
    "status": "Status",
    "scheduleAction": "Planlæg handlinger",
    "cancel": "Annuller",
    "pleaseWait": "Indlæser…",
    "confirm": "Bekræft",
    "booked": "Booket",
    "confirmed": "Bekræftet",
    "showed": "Fremmødte",
    "noShow": "Udeblevet",
    "cancelled": "Aflyst",
    "unread": "Ulæst",
    "engagement": "Engagement",
    "reaction": "Reaktion",
    "deliverySummary": "Leveringsoversigt",
    "successfulDelivery": "Vellykket levering",
    "opened": "Åbnet",
    "clicked": "Klikket",
    "replied": "Svarede",
    "unsubscribed": "Afmeldt",
    "complained": "Beklagede",
    "failed": "Mislykkedes",
    "bounced": "Afviste",
    "open": "Åben",
    "won": "Vundet",
    "abandoned": "Forladt",
    "lost": "Tabt",
    "sent": "Sendt",
    "eject": "Skub ud",
    "delivered": "Sendt",
    "faceBookLeadForm": "Facebook-kundeemneformular",
    "overdue": "Forfalden",
    "reviewsReceived": "Anmeldelser Modtaget",
    "formBuilders": "Formularbyggere",
    "switchToSaaS": "Skift til SaaS",
    "numberOfContacts": "Samlede antal kontakter",
    "numberOfAppointments": "Samlede antal aftaler",
    "outreach": "Opsøgende",
    "notSubAccountUser": "Ikke bruger af en underkonto",
    "searchSubAccName": "Søg efter underkontos navn",
    "recipients": "Modtagere",
    "scheduleCreated": "E-mailrapportskema oprettet for ",
    "scheduleUpdated": "E-mailrapportskema opdateret for ",
    "scheduleNotCreated": "E-mailrapportskema kunne ikke oprettes for",
    "scheduleNotUpdated": "E-mailrapportskema kunne ikke opdateres for",
    "total": "I alt",
    "inbound": "Indgående",
    "outbound": "Udgående",
    "totalEmails": "E-mails i alt",
    "inboundEmails": "Indgående e-mails",
    "outboundEmails": "Udgående e-mails",
    "totalTextMessages": "Samlet antal sms-beskeder",
    "inboundTextMessages": "Indgående sms-beskeder",
    "outboundTextMessages": "Udgående sms-beskeder",
    "totalCalls": "Opkald i alt",
    "inboundCalls": "Indgående opkald",
    "outboundCalls": "Udgående opkald",
    "faceBookLeadFormSubmissions": "Indsendelser af Facebook-kundeemneformularer",
    "inboundGMBMessages": "Indgående GBP-beskeder",
    "outboundGMBMessages": "Udgående GBP-beskeder",
    "totalIgMessages": "Instagram-beskeder i alt",
    "inboundIgMessages": "Indgående Instagram-beskeder",
    "outboundIgMessages": "Udgående Instagram-beskeder",
    "totalfbMessages": "Facebook-beskeder i alt",
    "inboundfbMessages": "Indgående Facebook-beskeder",
    "outboundfbMessages": "Udgående Facebook-beskeder",
    "sitesCreatedFunnels": "Websites oprettet – tragte",
    "sitesCreatedActiveFunnels": "Oprettede websteder – aktive tragte",
    "sitesCreatedWebsites": "Oprettede websites – websites",
    "sitesCreatedActiveWebsites": "Oprettede websites – aktive websites",
    "sitesCreatedForms": "Oprettede websites – formularer",
    "sitesCreatedActiveForms": "Oprettede sites – aktive formularer",
    "sitesCreatedSurveys": "Oprettede websites – undersøgelser",
    "sitesCreatedActiveSurveys": "Oprettede websites – aktive undersøgelser",
    "googleReviews": "Google-anmeldelser",
    "facebookReviews": "Facebook-anmeldelser",
    "inboundCallDuration": "Indgående opkaldsvarighed (timer)",
    "outboundCallDuration": "Varighed af udgående opkald (timer)",
    "pleaseSelect": "Vælg",
    "subAccountIsDeleted": "Denne underkonto er blevet slettet",
    "subAccountIsPaused": "Denne underkonto er blevet sat på pause",
    "success": "Gennemført",
    "error": "Fejl",
    "testEmailSent": "Test sendt",
    "testEmailNotSent": "Test kunne ikke sendes",
    "reviewRequest": "Anmeldelsesanmodning",
    "pendingTransferDescription": "Andre bureauer har anmodet om at overføre underkonti til dig.",
    "pendingTransferHeading": "Du har afventende anmodninger om overførsel af underkonti.",
    "subAccountTransfer": "Overførsler mellem underkonti",
    "manageSubAccTransfer": "Administrer dine anmodninger om overførsel af underkonti",
    "subAccRequest": "{tabName}-anmodninger for underkonto",
    "receive": "Arve",
    "send": "Send",
    "release": "Udgive",
    "requests": "{count} forespørgsler",
    "subAccLimit": "Brugsgrænsen for underkonti er nået.",
    "subAccPlanLimit": "Du har brugt 3/3 underkonti, der er tilladt i din nuværende plan.",
    "upgradeTime": "Det er tid til en opgradering!",
    "upgradeHigher": "Opgrader til en højere plan for at acceptere overførslen af underkontoen.",
    "browse": "Gennemse planer",
    "pendingTransferTitle": "En overførselsanmodning for denne underkonto er allerede under behandling.",
    "unableTransfer": "Kan ikke overføre underkontoen til dette bureau.",
    "unableEjectCancel": "Kan ikke annullere anmodningen om fjernelse af underkonto.",
    "EjectErrorDetails": "Anmodningen om fjernelse af underkontoen kan ikke annulleres.",
    "hippaErrorDescription": "Denne underkonto er HIPAA-aktiveret og kan ikke overføres til et ikke-HIPAA-agentur.",
    "pendingTransferErrorDescription": "Annuller den eksisterende overførselsanmodning for denne underkonto, før du opretter en ny.",
    "receivingAgency": "Modtagende agentur",
    "releasingAgency": "Udgivende agentur",
    "noOfContacts": "Samlede kontakter",
    "requestedDate": "Anmodet dato",
    "action": "Handling",
    "cancelTransfer": "Annuller overførsel",
    "decline": "Afvise",
    "cancelTransferRequest": "Annuller anmodning om overførsel af underkonto?",
    "cancelEjectRequest": "Vil du annullere anmodning om fjernelse af underkonto?",
    "cancelRequestDescription": "Det modtagende bureau vil ikke længere kunne se denne overførselsanmodning, og underkontoen {name} vil ikke blive overført.",
    "cancelEjectRequestDescription": "Den valgte bruger vil ikke længere kunne oprette et nyt agentur ud fra underkontoen {name}.",
    "declineRequest": "Vil du afvise anmodningen om overførsel af underkontoen?",
    "declineRequestDescription": "Anmodningen vil blive afvist, og underkontoen {name} vil ikke blive overført til dit agentur.",
    "approveTransfer": "Vil du overføre underkonto til dit agentur?",
    "approveTransferDescription": "{name} underkonto vil blive overført til Deres agentur.",
    "transferNow": "Overfør nu",
    "cancelNow": "Annuller nu",
    "transferErrorDetails": "Denne underkonto kan ikke overføres.",
    "cancelRequest": "Annuller forespørgsel",
    "received": "Modtaget",
    "approve": "Godkende",
    "goBack": "Gå tilbage",
    "done": "Færdig",
    "subAccountTransferred": "Underkontoen er blevet overført!",
    "subAccountTransferDescription": "Selvom underkontoen er blevet overført, kan nogle aktiver som brugere, telefonnumre, Mailgun-konti og Yext-lister stadig tage 10–15 minutter om at blive synlige på destinationen.",
    "activeSubscriptionsAlert": "Placeringen har Dynamisk Abonnement. Annuller hver Abonnement Før Blind overførsel af Placeringen. Liste over Dynamisk Abonnement: {subscriptions}",
    "isSaasEnabled": "SaaS aktiveret",
    "typeToSearch": "Skriv for at søge",
    "dateAdded": "Dato tilføjet",
    "emailEngagement": "E-mailengagement",
    "emailReaction": "E-mailreaktion",
    "emailDeliverySummary": "E-mail leveringsoversigt",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Kontooversigt – {subAccountName}",
    "test": "Test",
    "scheduleExists": "Der findes et skema",
    "aToZ": "A - Å",
    "zToA": "Z - A",
    "onlyAdminUsersCanAddNewSubAccounts": "Kun administratorbrugere kan tilføje nye underkonti.",
    "locationName": "Placeringsnavn",
    "transferCompleted": "Overførselsanmodning for denne placering er allerede behandlet. Opdater siden.",
    "unauthorizedTransfer": "Du er ikke godkendt til at udføre denne håndtering. Kun Agentur-ejere kan udføre denne håndtering.",
    "bulkLocationTransfer": "Underkonto til masseoverførsel",
    "singleRequest": "Enkelt anmodning",
    "bulkRequest": "Forespørgsel om større mængder",
    "backToLocationTransfer": "Tilbage til overførsel af placering",
    "initiateBulkTransfer": "Indled masseoverførsel af underkonti",
    "initiateBulkTransferDescription": "Vælg de underkonti, du ønsker at overføre, eller indtast deres id'er adskilt med kommaer.",
    "subAccountId": "Underkonto-id",
    "selectFromList": "Vælg fra listen",
    "addManually": "Tilføj manuelt",
    "accountsSelected": "{count} valgt",
    "selectAllSubAccounts": "Vælge hver",
    "removeAll": "Fjern alle",
    "addManualLocations": "Tilføj placerings-id'er adskilt af kommaer",
    "manualAllLocationIds": "Placering ID'er af underKonto Du ønsker at Overfør, Adskilt Via komma.",
    "enterLocationIds": "Indtast placerings-id'er",
    "selectSubAccounts": "Vælg underkonti, og overfør til et eksisterende agentur",
    "subAccountTransferWarning": "hver under-Konto-aktiver og Bruger vil få Download.",
    "proceed": "Fortsæt",
    "bulkRequestSubmitted": "Anmodning om masseoverførsel er indsendt",
    "bulkRequestSubmittedDescription": "Hver underkonto vil blive overført, når det modtagende agentur accepterer overførselsanmodningen. Du kan følge status for anmodningen på ❝{pagename}❞-siden. (forudsat at de er berettigede)",
    "bulkTransferRequestFailed": "Anmodning om masseoverførsel mislykkedes",
    "errorLocations": "Underkonti med fejl",
    "viewDetails": "Vis oplysninger",
    "somethingWrong": "Der opstod en fejl. Prøv igen.",
    "confirmBulkRequest": "Bekræfter du anmodningen om masseoverførsel?",
    "bulkTransferAccounts": "Masseoverfør '{count}' af valgte underkonti?",
    "confirmDetails": "Bekræft oplysningerne, før du overfører.",
    "transferConsent": "Jeg har Læse og forstod ovenstående vejledning og Samtykke hver begrænsningerne.",
    "transferInfo": "Overførslen af underkontoen kræver, at det modtagende agentur accepterer den i deres konto.",
    "receivingRelNo": "Modtagende agenturs relationsnummer",
    "enterRelNo": "Indtast relationsnummer",
    "transferConfirmation": "Efter afslutning af denne håndtering vil Større mængder Overfør Forespørgsler blive sendt til Modtaget Agentur ({ relNo }). hver under-Konto Du've Valgt vil blive Download, når Modtaget Agentur accepterer det. Note , at denne håndtering er uigenkaldelig for hver underkonto, der er inkluderet in overførslen.",
    "confirmPassword": "Bekræft Ved at skrive password under",
    "enterPassword": "Indtast adgangskode",
    "requestTransfer": "Anmod om overførsel",
    "confirmTransfer": "Bekræft overførsel",
    "notNow": "Ikke nu",
    "invalidRelNo": "Ugyldigt relationsnummer",
    "invalidPassword": "Ugyldig password.",
    "searchSubAccounts": "Søg efter underkonti",
    "searchSubAccountsId": "Søg efter underkonto-id",
    "takeAction": "Tag affære",
    "sub_account_details": "Oplysninger om underkonto:",
    "no_of_contacts": "Samlede kontakter",
    "transfer_status": "Overførselsstatus",
    "error_info": "Fejlinformation",
    "bulk_transfer_status": "Status for masseoverførsel af underkonto",
    "pending": "Afventer",
    "processed": "Behandlet",
    "reject_all": "Afvis alle",
    "accept_all": "Acceptér alle",
    "cancel_all": "Aflys alle",
    "clearAll": "Ryd alt",
    "refresh": "Opdater",
    "rejected": "Afvist",
    "decline_transfer": "Afvis overførsel",
    "decline_bulk_transfer": "Afvis anmodning om masse- underkonto overfør?",
    "decline_bulk_transfer_description": "Anmodningen vil blive afvist, og de {length} underkonti vil ikke blive overført til dit agentur.",
    "accept_bulk_transfer": "Accepter anmodning om masseoverførsel af underkonto?",
    "accept_bulk_transfer_description": "Anmodningen vil blive accepteret, og de {length} underkonti vil blive overført til dit agentur.",
    "cancel_bulk_transfer": "Annullér masseoverførsel?",
    "cancel_bulk_transfer_description": "Er du sikker på, at du vil annullere denne masseoverførsel af {length} underkonti til \"{name}\"?",
    "consent_sub_account_transfer": "Læse og Samtykke til {link}",
    "sub_account_transfer_guidelines": "Retningslinjer for overførsel af underkonto",
    "valid_rel": "Indtast et gyldigt nummer",
    "something_went_wrong": "Der opstod en fejl. Prøv igen.",
    "export": "Eksportér",
    "export_success": "De data, Du anmodede om, behandles. Du vil give en e-mail med dataene in en eller anden Dato.",
    "export_failed": "De data, Du anmodede om, kunne ikke behandles. Prøv igen senere.",
    "selectAllError": "Du kan kun vælge 1.000 underkonti ad gangen.",
    "max1000": "(Maks. 1.000)",
    "subAccountCount": "Antal underkonti",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Er du sikker på, at du vil sætte {count} rapporter på Pause ?",
    "scheduleBulkResumeConfirm": "Er du sikker på, at du vil genoptage {count} rapporter?",
    "resume": "Genoptag",
    "pause": "Pause",
    "resumeSelected": "Genoptage Valgt",
    "pauseSelected": "Pause Valgt",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} rapporter valgt",
    "selectAllXReports": "Vælg alle {count} rapporter",
    "scheduleStatus": "Planlæg status",
    "scheduleSearchPlaceholder": "Søg ved hjælp af e-mail eller placering",
    "subAccountsPerPage": "Underkonti pr. side",
    "previous": "Tidligere",
    "scheduleBulkAction": "Planlæg massehandling",
    "all": "Alle",
    "active": "Aktiv",
    "paused": "Sat på pause",
    "scheduleUpdatedSuccessfully": "skema Opdateret",
    "saveChanges": "Gem ændringer",
    "pauseSchedulesTitle": "Pause Aktiv Planlagt rapporterer",
    "pauseSchedulesDescription": "klik for at Pause nu Aktiv-rapporter.",
    "pauseSchedulesAlert": "Dette vil kun påvirke Konto, der er nu Dynamisk.",
    "pauseAllSchedulesBtnText": "Sæt alle planlagte rapporter på pause",
    "autoScheduleTitle": "Automatisk planlægning for nye konti",
    "autoScheduleLabel": "Opret automatisk planlagte rapporter, når en ny underkonto tilføjes.",
    "autoScheduleAlert": "Deaktiver denne Hvis Du manuelt ønsker at Konfigurer for ny Konto.",
    "autoScheduleEnabledForNewAccounts": "Auto-Planlæg Aktiveret for ny Konto",
    "autoScheduleDisabledForNewAccounts": "Auto-Planlæg Deaktiveret for ny Konto",
    "deleted": "Slettet",
    "locationPaused": "Placering sat på pause",
    "scheduleSettingsModalTitle": "skema rapport Indstillinger",
    "selectAllSchedules": "Vælg hvert Planlæg",
    "selectScheduleForLocation": "Vælge skema for {location}",
    "openSettings": "Åbne Indstillinger",
    "resumeScheduleForLocation": "Genoptage skema for {location}",
    "pauseScheduleForLocation": "Pause skema på pause for {location}",
    "actions": "Handlinger",
    "deselectAll": "Fravælg hver",
    "scheduleBulkActionResumeSuccess": "Større mængder aktivering in gang — På hold Deaktiveret Til nye aktiviteter",
    "scheduleBulkActionPauseSuccess": "Sætter rapporter på pauser – vent med at foretage flere handlinger",
    "bulkActionCreationError": "En anden massehandling er i gang. Prøv igen om et øjeblik.",
    "bulkActionInProgress": "Større mængder Behandling in gang",
    "scheduledReports": "Planlagt rapporter",
    "scheduleBulkActionCompleted": "Større mængder Håndtering af Færdig",
    "pauseAllSchedulesModalTitle": "Vil du sætte rapporter på pause?",
    "pauseAllSchedulesModalText": "Dette vil sætte alle aktive planlagte rapporter på pause på tværs af underkonti.",
    "addLocationIdsPlaceholder": "Tilføj de placerings-id'er, du vil overføre ...",
    "helloWorld": {
      "count": "Antallet er {count}",
      "editIntro": "Rediger",
      "editAction": "At teste HMR",
      "checkOut": "Se nærmere på",
      "officialStarter": "den officielle Vue + Vite-starter",
      "install": "Installer",
      "installDescription": "I din IDE for at få en bedre DX",
      "learnMore": "Klik på Vite- og Vue-logoerne for at få mere at vide"
    },
    "home": {
      "testMessage": "Hej! Dette er en test-hjemmeside!"
    },
    "reports": {
      "incoming": "Indkommende",
      "outgoing": "Udgående",
      "duration": "Varighed",
      "contactsCount": "Samlede kontakter",
      "appointmentsCount": "Samlede aftaler",
      "formSubmissions": "Indsendelser af formularer",
      "surveySubmissions": "Indsendelser af undersøgelser",
      "facebookFormSubmissions": "Indsendelser af Facebook-formularer",
      "funnels": "Tragter",
      "websites": "Websites",
      "forms": "Formularer",
      "surveys": "Undersøgelser",
      "gbpMessages": "GBP-beskeder",
      "facebookMessages": "Facebook-beskeder",
      "instagramMessages": "Instagram-beskeder",
      "reviews": "Anmeldelser",
      "positives": "Positiver",
      "negatives": "Negativer"
    },
    "timeOptions": {
      "00": "00.00",
      "01": "01.00",
      "02": "02.00",
      "03": "03.00",
      "04": "04.00",
      "05": "05.00",
      "06": "06.00",
      "07": "07.00",
      "08": "08.00",
      "09": "09.00",
      "10": "10.00",
      "11": "11.00",
      "12": "12.00",
      "13": "13.00",
      "14": "14.00",
      "15": "15.00",
      "16": "16.00",
      "17": "17.00",
      "18": "18.00",
      "19": "19.00",
      "20": "20.00",
      "21": "21.00",
      "22": "22.00",
      "23": "23.00"
    },
    "transferStatus": {
      "pending": "Afventer",
      "processed": "Behandlet",
      "canceled": "Annulleret",
      "cancelled": "Annulleret",
      "completed": "Færdig",
      "rejected": "Afvist",
      "failed": "Mislykkedes",
      "payment_pending": "Afventer betaling"
    }
    }
